<span class="sd-resident-info-label" *ngIf="residentStatusCode === ResidentStatusCode.invite"
    title="Resident Status">Invited</span>

<span class="sd-resident-warning-label" *ngIf="residentStatusCode === ResidentStatusCode.application"
    title="Resident Status">Application</span>

<span class="sd-resident-success-label" *ngIf="residentStatusCode === ResidentStatusCode.approved"
    title="Resident Status">Approved</span>

<span class="sd-resident-success-label" *ngIf="residentStatusCode === ResidentStatusCode.funded"
    title="Resident Status">{{ fsdNotManaged ? 'Funded (Not-Managed)' : 'Funded' }}</span>

<span class="sd-resident-lease-ended-label" *ngIf="residentStatusCode === ResidentStatusCode.leaseEnded"
    title="Resident Status">{{ fsdNotManaged ? 'Lease ended (Not-Managed)' : 'Lease ended' }}</span>

<span class="sd-resident-error-label" *ngIf="residentStatusCode === ResidentStatusCode.evicted"
    title="Resident Status">Evicted</span>

<span class="sd-resident-warning-label" *ngIf="residentStatusCode === ResidentStatusCode.pendingRefund"
    title="Resident Status">Pending Refund</span>

<span class="sd-resident-info-label" *ngIf="residentStatusCode === ResidentStatusCode.refunded"
    title="Resident Status">Refunded</span>

<span class="sd-resident-info-label" *ngIf="residentStatusCode === ResidentStatusCode.claimPaidOut"
    title="Resident Status">Claim Paid Out</span>

<span class="sd-resident-error-label" *ngIf="residentStatusCode === ResidentStatusCode.archived"
    title="Resident Status">Archived</span>

<span class="sd-resident-error-label" *ngIf="residentStatusCode === ResidentStatusCode.chargebacked"
    title="Resident Status">Chargebacked</span>
